// @react/hooks/useProject.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectStore } from '@core/stores';

/**
 * React hook for Project operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProject } from '@react/hooks';
 *
 * const ProjectList = observer(() => {
 *   const store = useProject();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProject() {
  return projectStore;
}
